import * as React from 'react';
import { Radio } from '@mui/material';
import cn from 'classnames';

import { useTheme } from '../../../theme';
import { AeroexpressTrip } from '@websky/graphql';

interface Props {
	className?: string;
	label: string | React.ReactNode;
	trips: AeroexpressTrip[];
	value: AeroexpressTrip | undefined;
	onChange: (trip: AeroexpressTrip) => void;
}

const AeroexpressPassenger: React.FC<Props> = ({ className, label, trips, value, onChange }) => {
	const { AeroexpressPassenger: css } = useTheme('CheckoutAdditionalService');

	const onChangeHandler = (selectedTrip: AeroexpressTrip) => (
		_: React.ChangeEvent<HTMLInputElement>,
		checked: boolean
	) => {
		if (checked) {
			const tripByClass = trips.find(trip => trip.id === selectedTrip.id) ?? null;

			onChange(tripByClass);
		} else {
			onChange(null);
		}
	};

	return (
		<div className={cn(css.container, className)}>
			<div className={css.label}>{label}</div>
			<div className={css.controls}>
				{trips.map((trip, index) => (
					<div key={`${trip.id}-${index}`} className={css.control}>
						<Radio value={trip.class} checked={trip.id === value?.id} onChange={onChangeHandler(trip)} />
					</div>
				))}

				{/* TODO: uncomment this when php was ready */}
				{/*{trips.map((trip, index) =>*/}
				{/*	trip.fares?.map(fare => (*/}
				{/*		<div key={`${trip.id}-${index}`} className={css.control}>*/}
				{/*			<Radio*/}
				{/*				value={trip.class}*/}
				{/*				checked={trip.id === value?.id}*/}
				{/*				onChange={onChangeHandler(trip)}*/}
				{/*			/>*/}
				{/*		</div>*/}
				{/*	))*/}
				{/*)}*/}
			</div>
		</div>
	);
};

export default AeroexpressPassenger;
